"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OAuth = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _merge = _interopRequireDefault(require("lodash/merge"));

var _sbFetch = require("skybase-ui/skybase-core/services/sb-fetch");

var _emitter = require("skybase-ui/skybase-core/emitter");

var _service = require("./oauth/services/service");

var _kiconnectService = require("./oauth/services/kiconnect/kiconnect-service");

var _oauthHandlerInlineBased = require("./oauth/handlers/inline-based/oauth-handler-inline-based");

var _constants = require("./constants");

var _constants2 = require("./oauth/constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var LOCAL_SDK = _constants.APP_MODES.LOCAL_SDK,
    LOCAL_BACKEND = _constants.APP_MODES.LOCAL_BACKEND,
    NORMAL = _constants.APP_MODES.NORMAL;

var _OAuth = /*#__PURE__*/function () {
  function _OAuth() {
    var _this = this;

    (0, _classCallCheck2.default)(this, _OAuth);
    (0, _defineProperty2.default)(this, "_parseJSON", function (response) {
      return new Promise(function (resolve) {
        var responseType = response.headers.get('Content-Type');

        if (!responseType) {
          return resolve({
            status: response.status,
            ok: response.ok,
            json: {}
          });
        }

        var _responseCallback = function _responseCallback(data) {
          return resolve({
            status: response.status,
            ok: response.ok,
            json: data
          });
        };

        if (responseType.indexOf('application/json') !== -1) {
          return response.json().then(_responseCallback);
        }

        if (responseType.indexOf('text/plain') !== -1 || responseType.indexOf('text/html') !== -1) {
          return response.text().then(_responseCallback);
        }

        if (responseType.indexOf('application/pdf') !== -1) {
          return response.blob().then(_responseCallback);
        }

        return resolve({
          status: response.status,
          ok: response.ok,
          json: response
        });
      });
    });
    (0, _defineProperty2.default)(this, "_handle401Error", function (status) {
      if (status === 401 && !_this.isInLocalSDKMode) {
        // Clean up the local storage.
        _this.oAuthService.invalidateSession(); // Redirect to the OAuth Login page.


        _this.oAuthHandler.displayLoginPage();
      }
    });
    (0, _defineProperty2.default)(this, "fetchOAuth", function (url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // Get the access token from the store
      var _this$oAuthHandler$ge = _this.oAuthHandler.getAccessToken(),
          accessToken = _this$oAuthHandler$ge.accessToken;

      var _ref = options || {},
          _ref$headers = _ref.headers,
          headers = _ref$headers === void 0 ? {} : _ref$headers,
          restOptions = (0, _objectWithoutProperties2.default)(_ref, ["headers"]);

      var settings = {
        headers: _objectSpread(_objectSpread({
          'Content-Type': 'application/json'
        }, headers), !_this.isInLocalSDKMode ? {
          Authorization: "Bearer ".concat(accessToken)
        } : {})
      };
      var oAuthSettings = (0, _merge.default)({}, restOptions, settings);
      return new Promise(function (resolve, reject) {
        fetch(url, oAuthSettings).then(_this._parseJSON).then(function (response) {
          if (response.ok) {
            return resolve(response.json);
          }

          var _response$json = response === null || response === void 0 ? void 0 : response.json,
              errors = _response$json.errors;

          var status = response.status;

          _this._handle401Error(status); // extract the error from the server's json


          return reject({
            errors: errors,
            status: status || 0
          });
        }).catch(function (error, status) {
          _this._handle401Error(status);

          return reject({
            networkError: error.message,
            errors: null,
            status: 0
          });
        });
      });
    });
    (0, _defineProperty2.default)(this, "sbFetchOAuth", function (url) {
      var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // Get the access token from the store
      var _this$oAuthHandler$ge2 = _this.oAuthHandler.getAccessToken(),
          accessToken = _this$oAuthHandler$ge2.accessToken;

      var headers = args.headers,
          restArgs = (0, _objectWithoutProperties2.default)(args, ["headers"]);
      var settings = {
        headers: _objectSpread(_objectSpread({
          'Content-Type': 'application/json'
        }, headers || {}), !_this.isInLocalSDKMode ? {
          Authorization: "Bearer ".concat(accessToken)
        } : {})
      };
      var oAuthSettings = (0, _merge.default)({}, restArgs, settings);
      return (0, _sbFetch.sbFetch)(url, oAuthSettings).catch(function (error) {
        var _error$detail;

        var status = (_error$detail = error.detail) === null || _error$detail === void 0 ? void 0 : _error$detail.status; // If there is a 401 error, try to renew the token silently,
        // because the token was either invalidated on the backend, or the IS was restarted.

        if (status === 401 && !_this.isInLocalSDKMode) {
          _emitter.SbEmitter.emit('oAuth.TriggerSilentRenew'); // Clean up the local storage.


          _this.oAuthService.invalidateSession();

          return new Promise(function (resolve) {
            var currentAttempt = 0;

            var checkToken = function checkToken() {
              var _this$oAuthHandler$ge3 = _this.oAuthHandler.getAccessToken(),
                  renewedAccessToken = _this$oAuthHandler$ge3.accessToken;

              if (renewedAccessToken) {
                _emitter.SbEmitter.emit('oAuth.TriggerRetrieveIdToken');

                resolve(_this.sbFetchOAuth(url, args));
                return;
              }

              currentAttempt += 1;

              if (currentAttempt > 6) {
                // Token cannot be renewed silently, redirect to the OAuth Login page.
                _this.oAuthHandler.displayLoginPage();

                return;
              }

              setTimeout(function () {
                return checkToken();
              }, 500);
            };

            checkToken();
          });
        }

        throw error;
      });
    });

    // Remove the old access token if it was not removed manually from previous usage
    if (localStorage[_constants2.SESSION_KEY]) {
      localStorage.removeItem(_constants2.SESSION_KEY);
    }
  }

  (0, _createClass2.default)(_OAuth, [{
    key: "setConfig",
    value: function setConfig(config) {
      this.validateConfig(config);
      this.config = config;
    }
  }, {
    key: "throwOAuthParamError",
    value: function throwOAuthParamError(paramName) {
      throw new Error("[OAuthConfig] \"".concat(paramName, "\" is required parameter."));
    }
  }, {
    key: "validateConfig",
    value: function validateConfig(config) {
      if (config.APP_MODE !== LOCAL_SDK) {
        var IDENTITY_SERVER_URL = config.IDENTITY_SERVER_URL,
            CLIENT_ID = config.CLIENT_ID;

        if (!IDENTITY_SERVER_URL) {
          this.throwOAuthParamError('IDENTITY_SERVER_URL');
        }

        if (!CLIENT_ID) {
          this.throwOAuthParamError('CLIENT_ID');
        }
      } // SILENT_RENEW_REDIRECT_URI
      // if (!REDIRECT_URI) {
      //   this.throwOAuthParamError('REDIRECT_URI')
      // }
      //
      // if (!POST_LOGOUT_URI) {
      //   this.throwOAuthParamError('POST_LOGOUT_URI')
      // }
      //
      // if (!SCOPES) {
      //   this.throwOAuthParamError('SCOPES')
      // }

    }
  }, {
    key: "isInNormalMode",
    get: function get() {
      return !this.config.APP_MODE || this.config.APP_MODE === NORMAL;
    }
  }, {
    key: "isInLocalBackendMode",
    get: function get() {
      return this.config.APP_MODE === LOCAL_BACKEND;
    }
  }, {
    key: "isInLocalSDKMode",
    get: function get() {
      return this.config.APP_MODE === LOCAL_SDK;
    }
  }, {
    key: "oAuthService",
    get: function get() {
      if (!this.config) {
        throw new Error('You must set a config before using oauth.');
      }

      return new _service.Service(new _kiconnectService.KiconnectService(this.config));
    }
  }, {
    key: "oAuthHandler",
    get: function get() {
      return new _oauthHandlerInlineBased.OAuthHandlerInlineBased(this.oAuthService);
    }
  }]);
  return _OAuth;
}();

var OAuth = new _OAuth();
exports.OAuth = OAuth;
//# sourceMappingURL=oauth.js.map